<template>
  <div class="component-upload-image">
    <el-upload :action="uploadImgUrl" list-type="picture-card" :on-success="handleUploadSuccess"
      :before-upload="handleBeforeUpload" :limit="limit" :on-error="handleUploadError" :on-exceed="handleExceed"
      name="file" :on-remove="handleRemove" :show-file-list="true" :headers="headers" :file-list="fileList"
      :disabled="disabled" :on-preview="handlePictureCardPreview" :class="{ hide: this.fileList.length >= this.limit }"
      style="width:100%;height:100%;position: relative;">
      <img :src="bgImgUrl" width="100%" height="100%" />
      <!-- 上传图标 -->
      <div class="upload-icon">
        <i></i>
        <span>{{ uploadTitle }}</span>
      </div>
    </el-upload>

    <!-- 底部提示 -->
    <div class="el-upload__tip" slot="tip" v-if="showTip">
      请上传
      <template v-if="fileSize"> 大小不超过 <b style="color: #f56c6c">{{ fileSize }}MB</b> </template>
      <template v-if="fileType"> 格式为 <b style="color: #f56c6c">{{ fileType.join("/") }}</b> </template>
      的文件
    </div>

    <el-dialog :visible.sync="dialogVisible" title="预览" width="800" append-to-body>
      <img :src="dialogImageUrl" style="display: block; max-width: 100%; margin: 0 auto" />
    </el-dialog>
  </div>
</template>

<script>
  import { tokenStore } from "@/store/user.js";

  export default {
    name: "CardUpload",
    props: {
      value: [String, Object, Array],
      // 图片数量限制
      limit: {
        type: Number,
        default: 5,
      },
      // 大小限制(MB)
      fileSize: {
        type: Number,
        default: 5,
      },
      // 文件类型, 例如['png', 'jpg', 'jpeg']
      fileType: {
        type: Array,
        default: () => ["png", "jpg", "jpeg",],
      },
      // 是否显示提示
      isShowTip: {
        type: Boolean,
        default: true
      },
      //是否回显名字
      isName: {
        type: Boolean,
        default: false
      },
      // 禁用
      disabled: {
        type: Boolean,
        default: false
      },
      // 上传标题
      uploadTitle: {
        type: String,
        default: '请上传图片'
      },
      // 上传底图背景
      bgImgUrl: {
        type: String,
        default: require('@/assets/image/id-pros.png')
      }
    },
    data() {
      return {
        store: tokenStore(),
        dialogImageUrl: "",
        dialogVisible: false,
        hideUpload: false,
        baseUrl: '',
        uploadImgUrl: process.env.baseUrl + "/file/sys/file/upload", // 上传的图片服务器地址
        headers: {},
        token: '',
        fileList: [],
        name: '',
      };
    },
    mounted() {
      this.token = this.store.getToken
      this.headers = {
        Authorization: "Bearer " + this.token
      }

    },
    watch: {
      value: {
        handler(val) {
          if (val) {
            // 首先将值转为数组
            const list = Array.isArray(val) ? val : this.value.split(',');
            // 然后将数组转为对象数组
            this.fileList = list.map(item => {
              if (typeof item === "string") {
                if (item.indexOf(this.baseUrl) === -1) {
                  item = { name: this.baseUrl + item, url: this.baseUrl + item };
                } else {
                  item = { name: item, url: item };
                }
              }
              return item;
            });
          } else {
            this.fileList = [];
            return [];
          }
        },
        deep: true,
        immediate: true
      }
    },
    computed: {
      // 是否显示提示
      showTip() {
        return this.isShowTip && (this.fileType || this.fileSize);
      }
    },
    methods: {
      // 删除图片
      handleRemove(file, fileList) {
        let isImg = false;
        let fileExtension = "";
        if (file.name.lastIndexOf(".") > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
        }
        if (this.fileSize) {
          if (file.size) {
            const isLt = file.size / 1024 / 1024 < this.fileSize;
            if (!isLt) {
              this.$message.error(`上传的图片大小不能超过 ${this.fileSize} MB!`);
              return false;
            }
            fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
          }
        }
        isImg = this.fileType.some(type => {
          if (fileExtension && fileExtension.indexOf(type) > -1) return true;
          return false;
        });
        if (isImg) {
          const findex = this.fileList.map(f => f.name).indexOf(file.name);
          this.fileList.splice(findex, 1);
          if (this.isName) {
            this.$emit("input", this.fileList);
          } else {
            this.$emit("input", this.listTOArray(this.fileList));
          }
        }

      },
      // 上传成功回调
      handleUploadSuccess(res) {
        this.fileList.push({ name: this.name, url: res.data });
        if (this.isName) {
          this.$emit("input", this.fileList);
        } else {
          this.$emit("input", this.listTOArray(this.fileList));
        }
        this.loading.close();
      },
      // 上传前loading加载
      handleBeforeUpload(file) {
        let isImg = false;
        if (this.fileType.length) {
          let fileExtension = "";
          if (file.name.lastIndexOf(".") > -1) {
            fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
          }
          isImg = this.fileType.some(type => {
            if (file.type.indexOf(type) > -1) return true;
            if (fileExtension && fileExtension.indexOf(type) > -1) return true;
            return false;
          });
        } else {
          isImg = file.type.indexOf("image") > -1;
        }
        let name = file.name.slice(file.name.lastIndexOf(".") + 1)
        if (!isImg || this.fileType.indexOf(name) == -1) {
          this.$message.error(
            `文件格式不正确, 请上传${this.fileType.join("/")}图片格式文件!`
          );
          return false;
        }
        if (this.fileSize) {
          const isLt = file.size / 1024 / 1024 < this.fileSize;
          if (!isLt) {
            this.$message.error(`上传头像图片大小不能超过 ${this.fileSize} MB!`);
            return false;
          }
        }
        this.name = file.name;
        this.loading = this.$loading({
          lock: true,
          text: "上传中",
          background: "rgba(0, 0, 0, 0.7)",
        });
      },
      // 文件个数超出
      handleExceed() {
        this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`);
      },
      // 上传失败
      handleUploadError() {
        this.$message({
          type: "error",
          message: "上传失败",
        });
        this.loading.close();
      },
      // 预览
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      // 对象转成指定字符串分隔
      listToString(list, separator) {
        let strs = "";
        separator = separator || ",";
        for (let i in list) {
          strs += list[i].url.replace(this.baseUrl, "") + separator;
        }
        return strs != '' ? strs.substr(0, strs.length - 1) : '';
      },
      // 对象转成指定数组分隔
      listTOArray(list, separator) {
        let strs = [];
        for (let i in list) {
          strs.push(list[i].url)
        }
        return strs;
      }
    }
  };
</script>
<style scoped lang="scss">
  .component-upload-image {
    width: 345px;
    height: 232px;
    box-sizing: border-box;
    padding: 15px;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #f1f6f7;
  }

  ::v-deep.hide .el-upload--picture-card {
    display: none;
  }

  ::v-deep .el-upload-list--picture-card .el-upload-list__item {
    width: 100%;
    height: 100%;
  }

  // 去掉动画效果
  ::v-deep .el-list-enter-active,
  ::v-deep .el-list-leave-active {
    transition: all 0s;
  }

  ::v-deep .el-list-enter,
  .el-list-leave-active {
    opacity: 0;
    transform: translateY(0);
  }

  ::v-deep .el-upload--picture-card {
    width: 100%;
    height: 100%;

    .upload-icon {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;

      i {
        display: inline-block;
        width: 48px;
        height: 48px;
        background-image: url("@/assets/image/id-upload.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }

      span {
        margin-top: 10px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        line-height: 20px;
      }
    }
  }
</style>
